import type { FC } from 'react';
import { Stack, StackProps } from '@mui/material';

import { useTranslation } from '@mopla/i18';

import { WithPrivacyPolicyLink } from '../../organisms/PrivacyPolicy';
import { WithAGBLink } from '../../organisms/TermsOfUse';

import { FooterBrowserLink } from './ui/FooterBrowserLink';

export const PrivacyAndTermsRow: FC<StackProps> = (props) => {
	const { t } = useTranslation('logIn');

	return (
		<Stack
			{...props}
			gap={4}
			justifyContent="space-between"
			flexDirection="row"
		>
			<WithPrivacyPolicyLink
				render={(link) => (
					<FooterBrowserLink url={link}>
						{t('welcome:policy.privacy')}
					</FooterBrowserLink>
				)}
			/>
			<WithAGBLink
				render={(link) => (
					<FooterBrowserLink url={link}>
						{t('welcome:policy.terms')}
					</FooterBrowserLink>
				)}
			/>
		</Stack>
	);
};
